import React from "react";
import { Input } from "antd";
import { phonePrefix } from "../data/country";

type PhoneInputV2Props = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    status?: "" | "error" | "warning";
};

const PhoneInputV2 = ({ value, onChange, placeholder, status }: PhoneInputV2Props) => {
    const prefix = `(${phonePrefix})`;

    const formatPhoneNumber = (val: string) => {
        const cleaned = val.replace(/\D/g, '');
        let formatted = prefix;
        for (let i = 0; i < cleaned.length; i++) {
            if (i === 2 || i === 5 || i === 7) {
                formatted += " ";
            }
            formatted += cleaned[i];
        }
        return formatted;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let inputVal = e.target.value.replace(prefix, "").replace(/\s/g, "");
        if (/^\d*$/.test(inputVal) && inputVal.length <= 9) {
            onChange(inputVal);
        }
    };

    return (
        <Input
            placeholder={placeholder}
            value={formatPhoneNumber(value)}
            onChange={handleChange}
            status={status}
            style={{ width: '100%' }}
        />
    );
};

export default PhoneInputV2;
